import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/articles/[slug]/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleShare"] */ "/vercel/path0/src/components/ArticleShare/ArticleShare.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EditionModale"] */ "/vercel/path0/src/components/EditionModale/EditionModale.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Error/Error404.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BusinessModelCta"] */ "/vercel/path0/src/components/hestiaDesign/BusinessModelCta/BusinessModelCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BusinessModelHero"] */ "/vercel/path0/src/components/hestiaDesign/BusinessModelHero/BusinessModelHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RichBlocksRenderer"] */ "/vercel/path0/src/components/RichBlocks/RichBlocksRenderer.tsx");
